<script>
import { VueGoodTable } from 'vue-good-table';
import {mapActions, mapState } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const surveyApi = ClientFactory.get("surveys");

export default {
    components: {
        VueGoodTable
    },
    data () {
        return {
            tableData: [],
            columns: [
                {
                    label: 'Tên khảo sát',
                    field: 'name',
                    sortable: false
                },
                {
                    label: 'Trạng thái',
                    field: 'is_open',
                    width: '120px',
                    sortable: false,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    label: 'Ngày tạo',
                    field: 'created_date',
                    sortable: false,
                    width: '120px'
                },
                {
                    label: 'Thao tác',
                    field: 'action',
                    sortable: false,
                    width: '180px',
                    tdClass: 'text-center'
                },
            ],
            state: {
                dialog: {
                    detail: false,
                    delete: false
                },
                is_open: true
            },
            surveyItemDetail:"",
            survey_delete_id: -1,
            survey_id: -1
        }

    },
    methods: {
        ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
        async getSurveys() {
            this.loading(this.$vs);
            this.tableData = await surveyApi.getSurveys(this.AppActiveUser.account_id);
            this.closeLoading();
        },
        displaySurveyDetail(row) {
            this.state.dialog.detail = true;
            this.state.is_open = (row.is_open == 1);
            this.survey_id = row.id;
            this.surveyItemDetail = row;

        },
        displaySurveyDelete(row) {
            this.state.dialog.delete = true;
            this.survey_delete_id = row.id;
        },
        async changeOpenStatus(){
            this.loading(this.$vs);
            const response = await surveyApi.changeOpenSurveyStatus({
                id: this.survey_id,
                is_open: this.state.is_open ? 1 : -1
            });
            if(typeof response.error !== 'undefined') {
                return this.notify({
                    error: true,
                    text: response.error
                })
            }
            this.closeLoading();
            this.state.dialog.detail = false;
            this.getSurveys();
            
        },
        async deleteSurvey(id) {
            const response = await surveyApi.deleteSurveyById(id);
            if(typeof response.error !== 'undefined') {
                return this.notify({
                    error: true,
                    text: response.error
                })
            }
            this.state.dialog.delete = false;
            // reload surveys
            await this.getSurveys();
        },
        goParticipateSurvey(surveyId) {
            this.$router.push({ path: `participate/${surveyId}`}).catch(() => {});
        },
        goResultSurvey(surveyId) {
            this.$router.push({ path: `result/${surveyId}`}).catch(() => {});
        }
        
    },
    created() {
        //get surveys
        this.getSurveys();
    },
    computed: {
        ...mapState("auth", ["AppActiveUser"]),
    },
    destroyed() {
        this.closeLoading();
    },
}
</script>

<template>
    <div class="surveys-management">
         <CCard>
             <CCardHeader  class="pt-1 pb-1">
               <span class="card-header-title">Danh sách khảo sát</span>
               <vs-button square class="float-right md:mt-2" to='/surveys/create'><i class='bx bx-plus'></i>&nbsp;Tạo khảo sát</vs-button>
            </CCardHeader>
            <CCardBody>
                <vue-good-table
                    :columns="columns"
                    :rows="tableData"
                    compactMode
                    :pagination-options="{
                        enabled: true,
                        perPageDropdownEnabled: false,
                        nextLabel: 'Trang sau',
                        prevLabel: 'Trang trước',
                        ofLabel: 'của',
                    }"
                >
                    <div slot="emptystate">
                        Không có dữ liệu
                    </div>
                    <template
                        slot="table-row"
                        slot-scope="props"
                    >
                        <div v-if="props.column.field === 'is_open'">
                            &nbsp;<CBadge v-if="props.row.is_open == 1" color="success">Đang mở</CBadge>
                            <CBadge v-else color="danger">Đã kết thúc</CBadge>
                        </div>
                        <div v-else-if="props.column.field === 'action'" class="row">
                            <vs-tooltip>
                                <vs-button v-b-tooltip.hover transparent @click="displaySurveyDetail(props.row)" circle icon><i class='bx bx-detail'></i></vs-button>
                                <template #tooltip>
                                    Xem thông tin khảo sát
                                </template>
                            </vs-tooltip>
                            <vs-tooltip color="success">
                                <vs-button transparent @click="goResultSurvey(props.row.id)" success circle icon><i class='bx bxs-bar-chart-alt-2'></i></vs-button>
                                <template #tooltip>
                                    Xem kết quả
                                </template>
                            </vs-tooltip>
                            <vs-tooltip color="#f9b115">
                                <vs-button transparent @click="goParticipateSurvey(props.row.id)" :disabled="props.row.is_open != 1" color="#eb7a09" circle icon><i class='bx bxs-arrow-to-right'></i></vs-button>
                                <template #tooltip>
                                    Thực hiện khảo sát
                                </template>
                            </vs-tooltip>
                            <vs-tooltip color="danger">
                                <template #tooltip>
                                    Xóa khảo sát
                                </template>
                                <vs-button transparent @click="displaySurveyDelete(props.row)" danger circle icon><i class='bx bx-trash'></i></vs-button>
                            </vs-tooltip>
                           
                        </div>
                    </template>
                </vue-good-table>
            </CCardBody>
        </CCard>
        <vs-dialog prevent-close width="550px" v-model="state.dialog.detail">
            <h4 style="font-weight: bold;">{{surveyItemDetail.name}}</h4>
            <p style="font-style: italic;"> {{surveyItemDetail.description || `Không có miêu tả`}}</p>
            <hr>
            <CRow class="ml-0 mb-1">
                <span><b>Trạng thái:</b> &nbsp;
                    <CBadge v-if="surveyItemDetail.is_open == 1" color="success">Đang mở</CBadge>
                    <CBadge v-else color="danger">Đã kết thúc</CBadge>
                </span>
            </CRow>
            <CRow class="ml-0 mb-1">
                <span><b>Đối tượng khảo sát:</b> {{surveyItemDetail.group_name}}</span>
            </CRow>
            <CRow class="ml-0 mb-1">
                <span><b>Ngày tạo:</b> {{surveyItemDetail.created_date}}</span>
            </CRow>
            <CRow class="ml-0 mb-1">
                <span class="mr-2"><b>Đóng/mở khảo sát:</b> </span>
                <CSwitch  size= "sm" :checked.sync="state.is_open" color="success" labelOn="ON" labelOff="OFF"></CSwitch>
            </CRow>
            
            
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button transparent danger @click="changeOpenStatus" class="m-0" square>
                        Cập nhật
                    </vs-button>
                    <vs-button transparent dark @click="state.dialog.detail = false" class="m-0" square>
                        Hủy
                    </vs-button>
                </div>
            </template>
        </vs-dialog>
        <vs-dialog prevent-close width="450px" v-model="state.dialog.delete">
            <template #header>
                <h4 class="not-margin">
                    Xác nhận
                </h4>
            </template>
            <span class="center">Bạn có chắc chắn muốn xóa khỏi hệ thống?</span>
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button danger transparent @click="deleteSurvey(survey_delete_id)">
                       Xóa
                    </vs-button>
                    <vs-button @click="state.dialog.delete = false" dark transparent>
                       Hủy
                    </vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>

<style lang="scss">
    .surveys-management {
        .vgt-responsive {
            overflow-x: inherit;
        }
        table.vgt-table td {
            vertical-align: inherit;
            padding: 0em 0.75em 0em 0.75em;
        }
        .form-check-label {
            margin-bottom: -8px;
            margin-left: 10px;
        }
    }

</style>